import { observer } from 'mobx-react-lite';
import { PUBLIC_URL } from '../../__common/env';
import { Divider, message, Popover } from 'antd';
import { useState } from 'react';
import { useMainContext } from '../../hooks/useMainContext';
import { MdLogin } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { FiUser } from 'react-icons/fi';
import { FiHelpCircle } from 'react-icons/fi';
import { MdLogout } from 'react-icons/md';
import { performLogout } from '../../utils/logoutUtils';
import { useAuth } from 'react-oidc-context';
import useUserSession from '../../_hooks/useUserSession';
import { FaRegUserCircle } from 'react-icons/fa';
import { getInitials } from '../../utils/uiUtils';

const UserMenu = observer(() => {
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const { viewManager } = useMainContext();
    const initials = getInitials(
        viewManager.userData?.firstName,
        viewManager.userData?.email,
    );
    return (
        <Popover
            content={<PopoverContent setUserMenuOpen={setUserMenuOpen} />}
            arrow={false}
            trigger="click"
            open={userMenuOpen}
            popupStyle={{ zIndex: 999 }}
            styles={{
                body: {
                    boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.16)',
                    border: '1px solid #B6B6B6',
                    padding: '0px',
                    fontSize: '14px',
                    fontWeight: '400',
                    backgroundColor: '#E7E7E7 !important',
                    minWidth: '220px',
                    maxWidth: '310px',
                    width: 'fit-content !important',
                    marginTop: '0px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                },
            }}
            onOpenChange={(open) => setUserMenuOpen(open)}
            placement="bottomRight">
            <div className="w-[48px] h-[48px] rounded-full bg-theme-black flex justify-center items-center text-theme-white cursor-pointer">
                {viewManager.isLoggedIn ? (
                    initials ? (
                        <h1 className="text-[24px] font-[700] leading-[24px]  uppercase">
                            {initials}
                        </h1>
                    ) : (
                        <FaRegUserCircle className="text-[28px]" />
                    )
                ) : (
                    <FaRegUserCircle className="text-[28px]" />
                )}
            </div>
        </Popover>
    );
});

export default UserMenu;

const PopoverContent = observer(({ setUserMenuOpen }) => {
    const { viewManager } = useMainContext();
    const { logOutUser } = useUserSession();
    const auth = useAuth();
    const logout = async () => {
        const result = await performLogout(auth, logOutUser, viewManager);
        if (result.success) {
            return Promise.resolve(result.message);
        } else {
            return Promise.reject(new Error(result.message));
        }
    };
    const navigate = useNavigate();
    const handleLogout = async () => {
        try {
            setUserMenuOpen(false);
            logout().then(() => {
                message.success('Logout successful');
                window.location.reload();
            });
        } catch (error) {
            console.error('Logout error:', error);
            message.error(error?.message || 'Logout failed');
        }
    };
    const menuButtons = [
        {
            name: 'Profile',
            icon: FiUser,
            onClick: () => {},
        },
        {
            name: 'Help & Support',
            icon: FiHelpCircle,
            onClick: () => {},
        },
    ];

    const initials = getInitials(
        viewManager.userData?.firstName,
        viewManager.userData?.email,
    );
    return (
        <div className="">
            {viewManager.isLoggedIn ? (
                <div className="flex flex-col  items-center bg-theme-header-bg  py-[12px] ">
                    <div className="flex  items-center flex-col ">
                        <div className="h-[40px] w-[40px] flex justify-center items-center bg-theme-button-bg rounded-full hover:bg-theme-orange cursor-pointer hover:text-white transition-all ">
                            {initials ? (
                                <span className="font-favorit text-[18px] font-medium leading-[16px] uppercase ">
                                    {initials}
                                </span>
                            ) : (
                                <FiUser className="w-[24px] h-[24px] cursor-pointer" />
                            )}
                        </div>

                        <div className="ml-[8px]">
                            {viewManager.userData?.name && (
                                <h1 className="font-favorit text-[16px] font-medium leading-[16px] text-theme-black mt-[4px] text-center">
                                    {viewManager.userData.name}
                                </h1>
                            )}

                            {viewManager.userData?.email && (
                                <p className="font-favorit text-[12px] font-medium leading-[14px] text-[#5B5F5D]">
                                    {viewManager.userData.email}
                                </p>
                            )}
                        </div>
                    </div>
                    <Divider className="!my-[12px]  !border-theme-button-bg" />
                    <div className="flex flex-col  w-full px-[16px]">
                        {menuButtons.map((button, index) => (
                            <button
                                key={index}
                                className="flex items-center h-[36px] p-[16px] w-full hover:bg-gray-200  transition-all duration-300 ease-in-out group"
                                onClick={() => {
                                    button.onClick();
                                    setUserMenuOpen(false);
                                }}>
                                <button.icon className="w-[20px] h-[20px] cursor-pointer" />

                                <span className="font-favorit text-[14px] font-medium leading-[16px] text-theme-black ml-[8px]">
                                    {button.name}
                                </span>
                            </button>
                        ))}
                    </div>
                    <Divider className="!my-[12px]  !border-theme-button-bg" />
                    <div className="flex w-full px-[16px]">
                        {' '}
                        <button
                            className="flex items-center h-[36px] p-[16px] w-full hover:bg-gray-200 text-red-500  transition-all duration-300 ease-in-out group"
                            onClick={handleLogout}>
                            <MdLogout className="w-[20px] h-[20px] cursor-pointer" />

                            <span className="font-favorit text-[14px] font-medium leading-[16px]  ml-[8px]">
                                Logout
                            </span>
                        </button>
                    </div>
                </div>
            ) : (
                <div className="flex flex-col  items-center bg-theme-header-bg p-[8px] py-[12px] ">
                    <div
                        onClick={() => {
                            navigate('/auth/login');
                        }}
                        className="h-[40px] w-[40px] flex justify-center items-center bg-theme-button-bg rounded-full hover:bg-theme-orange cursor-pointer hover:text-white transition-all ">
                        <MdLogin className="w-[24px] h-[24px] cursor-pointer" />
                    </div>
                    <h1 className="font-favorit text-[18px] font-medium leading-[16px] text-theme-black mt-[8px]">
                        Welcome!
                    </h1>
                    <p className="font-favorit text-[14px] font-medium leading-[14px] text-[#5B5F5D] mt-[4px]">
                        Continue with sign-in
                    </p>
                </div>
            )}
        </div>
    );
});
